import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { Button } from '@/components/v4';
import { VIEW_MODES } from '../constants';

// Same segmented pill track as UploadMethodSelector on Add Number Blocks.
const ViewSwitch = ({ view, onChange, selectedCount }) => {
    const { darkMode } = useSelector((state) => state.settings);
    const options = [
        { value: VIEW_MODES.FULL, label: 'Full' },
        { value: VIEW_MODES.SPLIT, label: 'Split View' },
        { value: VIEW_MODES.SELECTED, label: `Selected (${selectedCount})` },
    ];

    return (
        <Box
            display="inline-flex"
            borderRadius="full"
            p="3px"
            bg={darkMode ? 'gray.700' : 'gray.200'}
            flexShrink={0}
            role="group"
            aria-label="View">
            {options.map((option) => {
                const isActive = view === option.value;
                return (
                    <Button
                        key={option.value}
                        borderRadius="full"
                        size="sm"
                        px={{ base: 3, sm: 5 }}
                        variant={isActive ? 'solid' : 'ghost'}
                        color={
                            isActive
                                ? undefined
                                : darkMode
                                  ? 'gray.100'
                                  : 'gray.700'
                        }
                        aria-pressed={isActive}
                        onClick={() => onChange(option.value)}
                        _hover={
                            isActive
                                ? {}
                                : { bg: darkMode ? 'gray.600' : 'gray.300' }
                        }>
                        {option.label}
                    </Button>
                );
            })}
        </Box>
    );
};

export default ViewSwitch;
